import * as React from "react";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import View from "zq-ui-v3/components/View/View";

const PageTitle: React.FC<any> = ({ title, className, menusMap, itemList }) => {
  const getName = (v) => {
    return menusMap?.[v]?.title;
  };
  return (
    <View className={className}>
      {title}
      {itemList?.map((v, index) => (
        <React.Fragment key={index}>
          <View className={index < itemList.length - 1 ? "text-secondaryText" : ""}>
            {getName(v)}
          </View>
          {index < itemList.length - 1 && (
            <KeyboardArrowRightIcon className="text-secondaryText" fontSize="small" />
          )}
        </React.Fragment>
      ))}
    </View>
  );
};
export default PageTitle;
